/* eslint-disable react/jsx-key */
import "./ExpensesTable.scss";
import secondaryComponents from "..";
import useExpensesTable from "./useExpensesTable";
import Images from "../../../assets/images";
import { RoutedModal } from "../../common";

const ExpensesTable = ({
  metaDetails,
  expenses,
  isViaSellMode = false,
  isRecurringTab = false,
  handleFetchExpenses = () => {},
  gotoPage = () => {},
}) => {
  const {
    instance,
    expenseDetails,
    isFetchingExpenseDetails,
    expenseView,
    setExpenseView,
  } = useExpensesTable({
    expenses,
    isViaSellMode,
    isRecurringTab,
    handleFetchExpenses,
  });
  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } =
    instance;

  return (
    <div className="expenses-table">
      <div className="expenses-table__content">
        <secondaryComponents.TableHelper
          getTableProps={getTableProps}
          getTableBodyProps={getTableBodyProps}
          headerGroups={headerGroups}
          rows={rows}
          prepareRow={prepareRow}
          hasAction={true}
        >
          <div className="text-center mt-5 mb-5">
            <img src={Images.expense2EmptyState} width="250px" alt="" />
            <h4 className="font-weight-semibold text-center mt-4">
              You have no expense
            </h4>
            <p className="text-center">
              Use the button above to create an expense. When you do, they would
              appear here.
            </p>
          </div>
        </secondaryComponents.TableHelper>

        {expenses?.length > 0 && (
          <div className="mt-auto">
            <secondaryComponents.Pagination
              totalPageNumber={metaDetails?.last_page}
              handlePageClick={(value) => gotoPage(value?.selected + 1)}
              currentPage={metaDetails?.current_page}
            />
          </div>
        )}
      </div>

      <RoutedModal
        isActive={expenseView?.id !== null && expenseView?.type === "UPDATE"}
        closeModal={() => setExpenseView({ type: null, id: null })}
        headerTitle={"Update Expense"}
        headerDescription="Record and initiate disbursements."
        width={1000}
      >
        <secondaryComponents.LoaderHelper
          isLoading={isFetchingExpenseDetails}
          classNames={"mt-5"}
        >
          <secondaryComponents.CreateExpense
            isEditMode={true}
            expenseInfo={expenseDetails}
            closeWidget={() => setExpenseView({ type: null, id: null })}
            handleFetchExpenses={handleFetchExpenses}
          />
        </secondaryComponents.LoaderHelper>
      </RoutedModal>

      <RoutedModal
        isActive={expenseView?.id !== null && expenseView?.type === "REVIEW"}
        closeModal={() => setExpenseView({ type: null, id: null })}
        headerTitle={"Review Expense"}
        headerDescription="Record and initiate disbursements."
        width={1000}
      >
        <secondaryComponents.LoaderHelper
          isLoading={isFetchingExpenseDetails}
          classNames={"mt-5"}
        >
          <secondaryComponents.ExpenseReview
            closeWidget={() => setExpenseView({ type: null, id: null })}
            expense={expenseDetails}
            handleFetchExpenses={handleFetchExpenses}
          />
        </secondaryComponents.LoaderHelper>
      </RoutedModal>
    </div>
  );
};

export default ExpensesTable;
